export interface UserDisplayProfile {
  name?: string;
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  email?: string;
  role?: unknown;
}

export function getDisplayName(profile?: UserDisplayProfile): string {
  return (
    profile?.name ||
    [profile?.given_name, profile?.family_name].filter(Boolean).join(" ") ||
    profile?.preferred_username ||
    profile?.email ||
    "User"
  );
}

export function getFirstName(profile?: UserDisplayProfile): string | undefined {
  const firstName = profile?.given_name || profile?.name?.split(" ").find(Boolean);
  if (firstName) return firstName;

  const username = profile?.preferred_username || profile?.email;
  const firstPart = username?.split("@")[0]?.split(".")[0];
  return firstPart ? firstPart.charAt(0).toUpperCase() + firstPart.slice(1) : undefined;
}

export function getInitials(profile?: UserDisplayProfile): string {
  return getDisplayName(profile)
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function getProfileRole(profile?: UserDisplayProfile): string | undefined {
  const role = profile?.role;

  if (typeof role === "string") return role;
  if (Array.isArray(role) && typeof role[0] === "string") return role[0];

  return undefined;
}
